import { isBefore } from 'date-fns';

const eduData = (arr: Array<any>) => {
  return arr.reduce((res, item) => {
    const result =
      res.length &&
      res.find(({ date }: { date: string }) => date === item.date);

    if (!result) res.push(item);
    else result.items = result.items.concat(item.items);

    return res.length
      ? res.sort((a: any, b: any) => {
          if (!a.date) return 1;
          if (!b.date) return -1;
          return isBefore(a.date, b.date) ? 1 : -1;
        })
      : res;
  }, []);
};

export default eduData;



// WEBPACK FOOTER //
// ./src/pages/profile/utils/eduData.ts